<template>
<events-section
	:station-ids="[stationId,]"
	:events-filter="['station_passport_edit',]"
	:table-height="easyDataTableHeight(false) - Number(headerHeight.replace(/[^0-9]/gi, ''))"
	:is-not-acknowledge-events="false"
	:is-about-pop-up="false"
/>
</template>




<script>
import EventsSection from '@/components/EventsSection/EventsSection.vue'
import { easyDataTableHeight } from '@/helpers.js'


export default {
	inject: ['headerHeight'],
	
	components: {
		EventsSection,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		return {
			easyDataTableHeight,
		}
	},

	data() {
		return {}
	},

	async created() {},

	mounted() {},

	methods: {},

	computed: {},
}
</script>




<style scoped>
</style>